export default __webpack_public_path__ + "static/media/Olive.3e160a68.jpg";